// @flow
import React from 'react';
import { Box } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { MAX_OFFERS } from '../helpers';
import RenderCost from '../CostField';

type Props = {
  disableFlags: Array<boolean>,
  providerNames?: Array<?string>,
};

const OfferRentRow = ({ disableFlags, providerNames = [] }: Props) => (
  <>
    {Array.from({ length: MAX_OFFERS }, (_, i) => i + 1).map((n) => (
      <RenderCost
        key={`offer${n}Rent`}
        fieldName={`offer${n}Rent`}
        disable={disableFlags[n - 1]}
        providerName={providerNames[n - 1]}
      />
    ))}
    <Box sx={{ width: 40, flexShrink: 0 }} />
  </>
);

export default OfferRentRow;
